import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {GeopointField, FieldReturn} from '../../types'

export const geopoint = (props?: GeopointField, mergeProps?: Partial<GeopointField>): FieldReturn =>
  field('geopoint', mergeConfig('geopoint', props, mergeProps))
